<template>
  <div v-show="show">
    <div class="acvitity_foot" @click="consultingClick">
      <div>立即咨询<span>(享课程优惠)</span></div>
    </div>
    <BranchChat ref="branch" @hideChat="hideChat" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { gioPlatform, getRegisterSourceInfo } from '@/utils/tools';
import BranchChat from '@/components/branchChat/index.vue';

export default {
  components: {
    BranchChat,
  },
  data() {
    return {
      groupProcessing: {},
      endTime: '',
      iosToLoginFrom: '', // ios中登录判断是从拼团还是普通订单
      gioCourseId: this.$route.query.courseId,
      isCollect: false, // 是否收藏
      collectInfo: {}, // 当前收藏的数据
      disabled: false, // 能否点击
      actionType: 0, // 1 登录后不需要跳转购买
      show: false,
    };
  },
  props: {
    by_stages_price: {
      type: [Number, String],
      default: 0,
    },
    buyBtnData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'course',
    },
    buyBtnLoading: {
      type: Boolean,
      default: false,
    },
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState(['courseBaseData', 'allAcvitity', 'productSku', 'userInfo', 'buyStatus']),
    // 当前售价
    salePrice() {
      const { sellPrice } = this.courseBaseData;
      const { nowAcvitity, activeType } = this.allAcvitity;
      const { price, productSkuId } = this.productSku;
      let salePrice = 0;
      if (!productSkuId) {
        // 售罄时展示产品中的价格
        salePrice = sellPrice;
      } else if (activeType <= 0 || activeType === 4) {
        // 无活动-展示sku价格
        salePrice = price;
      } else {
        // 活动价格
        salePrice = nowAcvitity?.promotionPrice;
      }
      return salePrice;
    },
    // 是否展示券后价格
    isShowCouponPrice() {
      const { isRepeatBuy } = this.courseBaseData;
      return (
        (this.buyBtnData.state === 10 && !this.buyStatus.length) ||
        (this.buyBtnData.state === 10 && isRepeatBuy === 1)
      );
    },
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // // 注册来源
    getSourceData(type) {
      // 4免费课程 5付费课程
      const sourceType = this.buyBtnData?.state === 6 ? 4 : 5;
      getRegisterSourceInfo(this, 'courseDetail', sourceType, type);
    },
    // 跳转 导学页（原生交互） h5页面需要弹窗提示去app查看
    goDirectoryPage() {
      const { isApp = false } = this.$root.$data;
      if (isApp) {
        this.$sendToApp('goDirectoryPage', { courseId: this.buyStatus[0]?.id }, false);
      } else {
        this.$emit('openAppDialog');
      }
    },
    consultingClick() {
      if (!this.userInfo.id && this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`;
        }
        const redirctUrl = encodeURIComponent(
          `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
        return;
      }
      if (!this.userInfo.id) {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        return;
      }
      this.$refs.branch.show = true;
    },
    gioEvent(item) {
      const { couponId, couponName, discountType } = item;
      // eslint-disable-next-line
      let disType = discountType === 1 ? '满减' : discountType === 2 ? '打折' : null;
      // 领取优惠券
      // eslint-disable-next-line
      gio('track', 'getCoupon_event', {
        getPage_var: '课程详情页面',
        courseId_var: this.gioCourseId ? this.gioCourseId.toString() : null, // 在课程详情页领取的卡券，该变量才会有值
        couponIdList_var: couponId,
        couponTypeList_var: disType, // 卡券类型列表
        couponNameList_var: couponName,
        platform_var: gioPlatform(),
      });
    },
    hideChat(data) {
      this.show = data;
    },
  },
};
</script>
<style scoped lang="scss">
.acvitity_foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: calc(120px + constant(safe-area-inset-bottom));
  height: calc(120px + env(safe-area-inset-bottom));
  padding: 19px 0;
  background: #fff;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);
  .disabled {
    opacity: 0.5;
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    text-align: center;
    background: #ff7f41;
    border-radius: 41px;
    span {
      color: #fff;
      font-weight: 400;
      font-size: 22px;
    }
  }
}
</style>
